export default __webpack_public_path__ + "static/media/downloads_icon.99b16879.svg";